//// Application Packages
import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'
import { selectForms } from '../../reducers/formSlice'

//// Application Components

//// Carbon Components
import { Button } from '@carbon/react'

//// Carbon Icons
import { PageFirst, PageLast } from '@carbon/icons-react'

//// Static Constants

//////// Component
const FormSubNavigationComponent = () => {
    //////// Hooks

    //////// State

    //////// Slices
    const settingsData = useSelector(selectSettings)
    const formsData = useSelector(selectForms)

    //// Slice Data
    const previous_route = settingsData?.['form']?.['previous_route']
    const next_route = settingsData?.['form']?.['next_route']
    const digital_name = settingsData?.['form']?.['digital_name']
    const dynamic_next_route1 = settingsData?.['form']?.['dynamic_next_route1']
    const dynamic_next_route2 = settingsData?.['form']?.['dynamic_next_route2']
    const dynamic_previous_route1 =
        settingsData?.['form']?.['dynamic_previous_route1']
    const dynamic_previous_route2 =
        settingsData?.['form']?.['dynamic_previous_route2']

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    //////// Memoization

    //////// Effects/Side Effects

    ////////////// Render & Return
    if (
        formsData?.['get-started']?.values?.GetStar === 'Y' &&
        formsData?.['get-started']?.values?.GetStarTwo === 'Y' &&
        digital_name === 'florida-center-for-nursing'
    ) {
        return (
            <>
                <nav className="form-sub-navigation-group">
                    <div className="form-sub-navigation-group-item">
                        <Link to={previous_route}>
                            <Button
                                className="fldoh-btn"
                                type="button"
                                kind="tertiary"
                                size="md"
                            >
                                Previous
                                <PageFirst />
                            </Button>
                        </Link>
                    </div>
                    <div className="form-sub-navigation-group-item">
                        <Link to={dynamic_next_route1}>
                            <Button
                                className="fldoh-btn"
                                type="button"
                                kind="tertiary"
                                size="md"
                            >
                                Next
                                <PageLast />
                            </Button>
                        </Link>
                    </div>
                </nav>
            </>
        )
    } else if (
        formsData?.['get-started']?.values?.GetStar === 'Y' &&
        formsData?.['get-started']?.values?.GetStarTwo === 'Y' &&
        digital_name === 'nurse-licensure-compact'
    ) {
        return (
            <>
                <nav className="form-sub-navigation-group">
                    <div className="form-sub-navigation-group-item">
                        <Link to={previous_route}>
                            <Button
                                className="fldoh-btn"
                                type="button"
                                kind="tertiary"
                                size="md"
                            >
                                Previous
                                <PageFirst />
                            </Button>
                        </Link>
                    </div>
                    <div className="form-sub-navigation-group-item">
                        <Link to={dynamic_next_route2}>
                            <Button
                                className="fldoh-btn"
                                type="button"
                                kind="tertiary"
                                size="md"
                            >
                                Next
                                <PageLast />
                            </Button>
                        </Link>
                    </div>
                </nav>
            </>
        )
    } else if (
        formsData?.['get-started']?.values?.GetStar === 'Y' &&
        formsData?.['get-started']?.values?.GetStarTwo === 'Y' &&
        digital_name === 'military-fee-waiver'
    ) {
        return (
            <>
                <nav className="form-sub-navigation-group">
                    <div className="form-sub-navigation-group-item">
                        <Link to={dynamic_previous_route1}>
                            <Button
                                className="fldoh-btn"
                                type="button"
                                kind="tertiary"
                                size="md"
                            >
                                Previous
                                <PageFirst />
                            </Button>
                        </Link>
                    </div>
                    <div className="form-sub-navigation-group-item">
                        <Link to={next_route}>
                            <Button
                                className="fldoh-btn"
                                type="button"
                                kind="tertiary"
                                size="md"
                            >
                                Next
                                <PageLast />
                            </Button>
                        </Link>
                    </div>
                </nav>
            </>
        )
    } else if (
        formsData?.['get-started']?.values?.GetStar === 'Y' &&
        formsData?.['get-started']?.values?.GetStarTwo === 'Y' &&
        digital_name === 'file-attachments'
    ) {
        return (
            <>
                <nav className="form-sub-navigation-group">
                    <div className="form-sub-navigation-group-item">
                        <Link to={dynamic_previous_route1}>
                            <Button
                                className="fldoh-btn"
                                type="button"
                                kind="tertiary"
                                size="md"
                            >
                                Previous
                                <PageFirst />
                            </Button>
                        </Link>
                    </div>
                    <div className="form-sub-navigation-group-item">
                        <Link to={next_route}>
                            <Button
                                className="fldoh-btn"
                                type="button"
                                kind="tertiary"
                                size="md"
                            >
                                Next
                                <PageLast />
                            </Button>
                        </Link>
                    </div>
                </nav>
            </>
        )
    } else if (
        formsData?.['get-started']?.values?.GetStar === 'Y' &&
        formsData?.['get-started']?.values?.GetStarTwo === 'N' &&
        digital_name === 'florida-center-for-nursing'
    ) {
        return (
            <>
                <nav className="form-sub-navigation-group">
                    <div className="form-sub-navigation-group-item">
                        <Link to={previous_route}>
                            <Button
                                className="fldoh-btn"
                                type="button"
                                kind="tertiary"
                                size="md"
                            >
                                Previous
                                <PageFirst />
                            </Button>
                        </Link>
                    </div>
                    <div className="form-sub-navigation-group-item">
                        <Link to={dynamic_next_route1}>
                            <Button
                                className="fldoh-btn"
                                type="button"
                                kind="tertiary"
                                size="md"
                            >
                                Next
                                <PageLast />
                            </Button>
                        </Link>
                    </div>
                </nav>
            </>
        )
    } else if (
        formsData?.['get-started']?.values?.GetStar === 'N' &&
        formsData?.['get-started']?.values?.GetStarTwo === 'Y' &&
        digital_name === 'florida-center-for-nursing'
    ) {
        return (
            <>
                <nav className="form-sub-navigation-group">
                    <div className="form-sub-navigation-group-item">
                        <Link to={previous_route}>
                            <Button
                                className="fldoh-btn"
                                type="button"
                                kind="tertiary"
                                size="md"
                            >
                                Previous
                                <PageFirst />
                            </Button>
                        </Link>
                    </div>
                    <div className="form-sub-navigation-group-item">
                        <Link to={dynamic_next_route2}>
                            <Button
                                className="fldoh-btn"
                                type="button"
                                kind="tertiary"
                                size="md"
                            >
                                Next
                                <PageLast />
                            </Button>
                        </Link>
                    </div>
                </nav>
            </>
        )
    } else if (
        formsData?.['get-started']?.values?.GetStar === 'Y' &&
        formsData?.['get-started']?.values?.GetStarTwo === 'N' &&
        digital_name === 'file-attachments'
    ) {
        return (
            <>
                <nav className="form-sub-navigation-group">
                    <div className="form-sub-navigation-group-item">
                        <Link to={dynamic_previous_route2}>
                            <Button
                                className="fldoh-btn"
                                type="button"
                                kind="tertiary"
                                size="md"
                            >
                                Previous
                                <PageFirst />
                            </Button>
                        </Link>
                    </div>
                    <div className="form-sub-navigation-group-item">
                        <Link to={next_route}>
                            <Button
                                className="fldoh-btn"
                                type="button"
                                kind="tertiary"
                                size="md"
                            >
                                Next
                                <PageLast />
                            </Button>
                        </Link>
                    </div>
                </nav>
            </>
        )
    } else if (
        formsData?.['get-started']?.values?.GetStar === 'N' &&
        formsData?.['get-started']?.values?.GetStarTwo === 'Y' &&
        digital_name === 'file-attachments'
    ) {
        return (
            <>
                <nav className="form-sub-navigation-group">
                    <div className="form-sub-navigation-group-item">
                        <Link to={dynamic_previous_route1}>
                            <Button
                                className="fldoh-btn"
                                type="button"
                                kind="tertiary"
                                size="md"
                            >
                                Previous
                                <PageFirst />
                            </Button>
                        </Link>
                    </div>
                    <div className="form-sub-navigation-group-item">
                        <Link to={next_route}>
                            <Button
                                className="fldoh-btn"
                                type="button"
                                kind="tertiary"
                                size="md"
                            >
                                Next
                                <PageLast />
                            </Button>
                        </Link>
                    </div>
                </nav>
            </>
        )
    } else if (previous_route && next_route) {
        return (
            <>
                <nav className="form-sub-navigation-group">
                    <div className="form-sub-navigation-group-item">
                        <Link to={previous_route}>
                            <Button
                                className="fldoh-btn"
                                type="button"
                                kind="tertiary"
                                size="md"
                            >
                                Previous
                                <PageFirst />
                            </Button>
                        </Link>
                    </div>
                    <div className="form-sub-navigation-group-item">
                        <Link to={next_route}>
                            <Button
                                className="fldoh-btn"
                                type="button"
                                kind="tertiary"
                                size="md"
                            >
                                Next
                                <PageLast />
                            </Button>
                        </Link>
                    </div>
                </nav>
            </>
        )
    } else if (previous_route) {
        return (
            <>
                <div className="form-sub-navigation-group">
                    <div className="form-sub-navigation-group-item">
                        <Link to={previous_route}>
                            <Button
                                className="fldoh-btn"
                                type="button"
                                kind="tertiary"
                                size="md"
                            >
                                Previous
                                <PageFirst />
                            </Button>
                        </Link>
                    </div>
                    <div className="form-sub-navigation-group-item">
                        <Link to={next_route}>
                            <Button
                                className="fldoh-btn"
                                type="button"
                                kind="tertiary"
                                size="md"
                                disabled={true}
                            >
                                Next
                                <PageLast />
                            </Button>
                        </Link>
                    </div>
                </div>
            </>
        )
    } else {
        return <></>
    }
}

export default FormSubNavigationComponent
